import { gql } from '@apollo/client';

const GET_USER = gql`
    query GetUser($netlifyId: ID!) {
        findUserByNetlifyID(netlifyId: $netlifyId) {
            id: _id
            subscriptionStatus
            accountReady
            emailAddress
            netlifyId
            stripeId
            subscription
            subscriptionPlanId
            activeSubscription
        }
    }
`;

const CREATE_COLOR = gql`
    mutation CreateColor($color: String!, $hue: Float!, $saturation: Float!, $lightness: Float!) {
        createColor(
            data: { color: $color, hue: $hue, saturation: $saturation, lightness: $lightness }
        ) {
            color
            hue
            saturation
            lightness
        }
    }
`;

const DELETE_COLOR = gql`
    mutation DeleteColorByColor($color: String!) {
        deleteColorByColor(color: $color) {
            color
        }
    }
`;

const GET_COLORS = gql`
    query GetAllColors {
        allColors {
            data {
                id: _id
                color
            }
        }
    }
`;

export { GET_USER, CREATE_COLOR, DELETE_COLOR, GET_COLORS };
